import { BrowserModule } from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { APP_BASE_HREF } from '@angular/common';
import { CookieModule } from 'ngx-cookie';
import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { InfiniteScrollModule } from "ngx-infinite-scroll";
import { TDMaterialModule } from './td.material.module';
import { FormsModule, ReactiveFormsModule }   from '@angular/forms';
import { A11yModule, LiveAnnouncer } from '@angular/cdk/a11y';
import { GridsterModule } from 'angular-gridster2';
import { NgStringPipesModule } from 'angular-pipes';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app.routing';
import {
  TermService,
  LocationService,
  ProgramService,
  AccountSettingService,
  ErrorConsoleService,
  ProgramDetailsService,
  ProgramParameterService,
  GooglePlacesService,
  ProgramBrochureService,
  ImageService,
  ProgramBudgetSheetService,
  ProgramDateSummaryService,
  OauthService,
  ProgramActiveAppCyclesService,
  CsrfService,
  DiscoveryService,
  LikeProgramService,
  TdsApiInterceptor,
  I18nService,
  ApplicationService,
  ProgramApiInterceptor,
  SettingsApiInterceptor,
  ApplicationApiInterceptor,
} from '@terradotta/commons';
import { AgmCoreModule } from '@agm/core';
// import { LoadingErrorsModule } from '../loading-errors/loading-errors.module';
import { ProgramDiscoveryPageComponent } from './program-discovery-page/program-discovery-page.component';
import { WizardBrochureModule } from '@terradotta/commons';
import { DiscoveryModule } from '@terradotta/commons';
import { environment } from '../environments/environment';

import { fas, faBook, faClipboardList, faPollH, faFileSignature, faInbox, faFile,
  faSortAmountDown, faArrowDown, faArrowUp, faEllipsisV, faUser,
  faAddressCard, faChevronCircleRight, faInfoCircle, faEnvelope, faEnvelopeOpenText,
  faPrint, faCalendarDay, faTimes, faTasks, faEye, faPencilAlt,
  faSyncAlt, faCopy, faEraser, faPlus, faGlasses, faCommentAlt, faEdit,
  faMap, faSms, faGlobe, faExchangeAlt, faLink, faPlaneArrival, faPlaneDeparture,
  faMapMarkerAlt, faRedo, faFilter, faChevronDown, faLock, faMailBulk, faClone,
  faExternalLinkSquareAlt, faTrashAlt, faSearch, faDesktop, faExclamationCircle, faCheck, faCaretSquareLeft,
  faSignOutAlt,faCaretLeft,faCaretRight, faAsterisk, faCertificate, faRedoAlt,
  faFlask, faStar, faCog, faCogs, faUserPlus, faPencilRuler, faCaretUp, faCaretDown, faMinus,
  faHome, faUserFriends, faUserCircle, faUsers, faQuestionCircle as faQuestion, faDownload, faPhone, faUniversity, 
  faChevronCircleDown, faChevronCircleUp, faInfo } from '@fortawesome/free-solid-svg-icons';

import { faCreditCard, faCalendar, faStickyNote, faTimesCircle, faSave as farSave,
  faEdit as farEdit, faCircle as farCircle, faCheckCircle as farCheckCircle, faWindowMaximize as farWindowMaximize,
  faWindowRestore as farWindowRestore, faSquare as farSquare, faCheckSquare as farCheckSquare, faStar as farStar, faUserCircle as farUserCircle, 
faThumbsUp as farThumbsUp, faThumbsDown as farThumbsDown } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeModule, FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';


const appSettings = {
  API_URL: environment.TDS_URL + '/models/services/REST/index.cfm?endpoint=',
  IMAGE_URL: environment.TDS_URL + '/_customtags/ct_Image.cfm?Image_ID=',
  APIV2_URL: environment.APIV2_URL,
  TDS_URL: environment.TDS_URL,
  OAUTH_ENABLE: environment.oAuthEnabled,
  googleAPIKey: environment.googleAPIKey,
  assetsFolder: environment.assetsFolder,
  production: environment.production,
  testUserName: environment.testUserName,
  testUserPassword: environment.testUserPassword,
  SETTINGS_URL: environment.SETTINGS_URL,
  APPLICATION_URL: environment.APPLICATION_URL,
  PROCESS_ELEMENTS_URL: environment.PROCESS_ELEMENTS_URL,
  FILE_URL: environment.FILE_URL,
  PROGRAM_URL: environment.PROGRAM_URL,
}
@NgModule({
  declarations: [
    AppComponent,
    ProgramDiscoveryPageComponent
  ],
  imports: [
    BrowserModule,
    FontAwesomeModule,
    BrowserAnimationsModule,
    InfiniteScrollModule,
    TDMaterialModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    GridsterModule,
    AgmCoreModule.forRoot({
      apiKey: environment.googleAPIKey,
      libraries: ["places"]
    }),
    WizardBrochureModule,
    CookieModule.forRoot(),
    A11yModule,
    NgStringPipesModule,
    DiscoveryModule,
    NgxMatSelectSearchModule
  ],
  schemas: [ NO_ERRORS_SCHEMA ],
  providers: [
    {
      provide: APP_BASE_HREF,
      useValue : '/' 
    },
    TermService, 
    LocationService, 
    ProgramService,
    AccountSettingService,
    ErrorConsoleService,
    ProgramDetailsService,
    ProgramParameterService,
    GooglePlacesService,
    ProgramBrochureService,
    ImageService,
    ProgramDateSummaryService,
    ProgramBudgetSheetService,
    OauthService,
    ProgramActiveAppCyclesService,
    CsrfService,
    DiscoveryService,
    LikeProgramService,
    I18nService,
    LiveAnnouncer,
    ApplicationService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TdsApiInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: SettingsApiInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ApplicationApiInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ProgramApiInterceptor,
      multi: true
    },
    {
      provide: 'ApiScope',
      useValue: 'ProgramBrochureRead'
    },
    {
      provide: 'appSettings',
      useValue: appSettings
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(library: FaIconLibrary) {
    // Add an icon to the library for convenient access in other components
    library.addIconPacks(fas);
    library.addIcons(
      faBook,
      faClipboardList,
      faPollH,
      faFileSignature,
      faInbox,
      faQuestion,
      faFile,
      faCreditCard,
      faSortAmountDown,
      faArrowDown,
      faArrowUp,
      faEllipsisV,
      faUser,
      faAddressCard,
      faChevronCircleRight,
      faInfoCircle,
      faEnvelope,
      faEnvelopeOpenText,
      faPrint,
      faCalendarDay,
      faEdit,
      faCalendar,
      faTimes,
      faTasks,
      faStickyNote,
      faTimesCircle,
      faEye,
      faPencilAlt,
      faSyncAlt,
      faCopy,
      faEraser,
      faPlus,
      faGlasses,
      faCommentAlt,
      faMap,
      faSms,
      faGlobe,
      faExchangeAlt,
      faLink,
      farCircle,
      farEdit,
      faPlaneArrival,
      faPlaneDeparture,
      faMapMarkerAlt,
      faRedo,
      faFilter,
      faChevronDown,
      faLock,
      faMailBulk,
      faClone,
      faExternalLinkSquareAlt,
      faTrashAlt,
      faPlus,
      faSearch,
      faDesktop,
      faExclamationCircle,
      faCheck,
      farSave,
      faCaretSquareLeft,
      faSignOutAlt,
      faCaretLeft,
      faCaretRight,
      farCheckCircle,
      faAsterisk,
      faCertificate,
      faRedoAlt,
      farWindowRestore,
      farWindowMaximize,
      faFlask,
      farCheckSquare,
      farSquare,
      faStar,
      farStar,
      faCog,
      faCogs,
      faUserPlus,
      faPencilRuler,
      faCaretUp,
      faCaretDown,
      faMinus,
      faHome,
      faUserFriends,
      faUserCircle,
      faUsers,
      farUserCircle,
      farThumbsDown,
      farThumbsUp,
      faDownload,
      faPhone, 
      faUniversity,
      faChevronCircleDown, 
      faChevronCircleUp,
      faInfo
    );
  }
 }
